/* eslint-disable @typescript-eslint/no-floating-promises */
// istanbul ignore file
import { exportARKpiDetailsErrorAction, exportARKpiDetailsLoadingAction, exportARKpiDetailsUpdateAction } from './exportARKpiDetailsSlice'
import { exportDonutKpiDetailsErrorAction, exportDonutKpiDetailsLoadingAction, exportDonutKpiDetailsUpdateAction } from './exportDonutKpiDetailsSlice'
import * as KpiHistoryService from '../services/historyTableService'
import { exportKSKpiDetailsErrorAction, exportKSKpiDetailsLoadingAction, exportKSKpiDetailsUpdateAction } from './exportKSKpiDetailsSlice'
import { exportBubbleKpiDetailsErrorAction, exportBubbleKpiDetailsLoadingAction, exportBubbleKpiDetailsUpdateAction } from './exportBubbleKpiDetailsSlice'

export const exportARKpiHistoryTable = (
  kpiType: string,
  inputDateRead: string,
  page: number,
  size: number, service: string) => async (dispatch: any) => {
  dispatch(exportARKpiDetailsLoadingAction())
  KpiHistoryService.getHistoryARTable(
    kpiType,
    inputDateRead,
    page,
    size,
    service,
    true,
    (data, httpStatus) => {
      dispatch(exportARKpiDetailsUpdateAction({ data, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(exportARKpiDetailsErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const exportKSKpiHistoryTable = (
  kpiType: string,
  inputDateRead: string,
  page: number,
  size: number, service: string) => async (dispatch: any) => {
  dispatch(exportKSKpiDetailsLoadingAction())
  KpiHistoryService.getHistoryKSTable(
    kpiType,
    inputDateRead,
    page,
    size,
    service,
    true,
    (data, httpStatus) => {
      dispatch(exportKSKpiDetailsUpdateAction({ data, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(exportKSKpiDetailsErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const exportDonutKpiHistoryTable = (
  kpiType: string,
  inputDateRead: string,
  donutType: string,
  page: number,
  size: number, service: string) => async (dispatch: any) => {
  dispatch(exportDonutKpiDetailsLoadingAction())
  KpiHistoryService.getHistoryDonutTable(
    kpiType,
    inputDateRead,
    donutType,
    page,
    size,
    service,
    true,
    (data, httpStatus) => {
      dispatch(exportDonutKpiDetailsUpdateAction({ data, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(exportDonutKpiDetailsErrorAction({ errorMessage, httpStatus }))
    }
  )
}

export const exportBubbleKpiHistoryTable = (
  kpiType: string,
  inputDateRead: string,
  donutType: string,
  page: number,
  size: number, service: string) => async (dispatch: any) => {
  dispatch(exportBubbleKpiDetailsLoadingAction())
  KpiHistoryService.getHistoryBubbleTable(
    kpiType,
    inputDateRead,
    donutType,
    page,
    size,
    service,
    true,
    (data, httpStatus) => {
      dispatch(exportBubbleKpiDetailsUpdateAction({ data, httpStatus }))
    },
    (errorMessage, httpStatus) => {
      dispatch(exportBubbleKpiDetailsErrorAction({ errorMessage, httpStatus }))
    }
  )
}
